/**
 * The module manifest.
 *
 * **This is the only file that changes to add a module.** Everything else — navigation,
 * routing, landing page, feature gating — is derived from what a module declares about
 * itself. `prove-module-extension-point.test.tsx` registers a throwaway module and
 * asserts it reaches both the navigation and the router with no other file touched, so
 * the claim in this comment is checked rather than asserted.
 *
 * Registration order is meaningful: it is the navigation order, and the first entry a
 * user's roles permit becomes their landing page.
 *
 * Repository readiness (RRI) will be added here as a third entry when it is built. Its
 * directory will sit beside the other two and import nothing from either.
 */

import { ModuleRegistry } from '../platform/modules/registry'
import { agenticDevKitModule } from './agentic-dev-kit/module'
import { aiTokenTrackerModule } from './ai-token-tracker/module'

export const MODULES = [aiTokenTrackerModule, agenticDevKitModule] as const

export function createModuleRegistry(): ModuleRegistry {
  return new ModuleRegistry(MODULES)
}
